import { userFacingErrorMessage } from "@/shared/http/userFacingErrorMessage";

import styles from "./VerifyOutcome.module.css";

interface VerifyOutcomeProps {
  /** What the last verify call answered; `undefined` before one completes. */
  result: { error: string | null } | undefined;
  /** Why the verify request itself failed (e.g. no model to test with), or `null`. */
  error: Error | null;
}

/**
 * The outcome of a Verify click, next to what it verified. The provider's
 * error itself shows on hovering the verified item's status, which the call
 * updates.
 */
export function VerifyOutcome({ result, error }: VerifyOutcomeProps) {
  if (error !== null) {
    return (
      <span className={styles.failure} role="alert">
        {userFacingErrorMessage(error)}
      </span>
    );
  }
  if (result === undefined) {
    return null;
  }
  return result.error === null ? (
    <span className={styles.success} role="status">
      Verification succeeded.
    </span>
  ) : (
    <span className={styles.failure} role="alert">
      Verification failed.
    </span>
  );
}
